/* eslint-disable no-eval */
import { execEvaluateExpression } from './evaluateExpression/execEvaluateExpression.js';
import { unwrapGlobalVariables, wrapGlobalVariables } from './evaluateExpression/globalVariables.js';
import { formatErrorAsObject } from './formatErrorAsObject.js';
import { instrumentCodeWithLoopProtection } from './instrumentCodeWithLoopProtection.js';
import { interceptStdout } from './interceptStdout.js';

export const evaluateExpression = async ({ expression, input, globalVariables = {}, arrowFunction = true, inputLabel = 'input', intercept = false, evalMode = false, useVM = true, meta = {} }) => {
  if (!expression) {
    return { success: true, data: input, message: 'No expression to evaluate.' };
  }

  globalThis.evaluateExpressionCount++;

  let unhook;
  let allStdout = '';
  const chunks = [];

  const handleChunk = (chunk) => {
    let rawChunk;
    if (typeof chunk === 'object') {
      rawChunk = JSON.stringify(chunk, null, 2);
    } else if (typeof chunk === 'string') {
      rawChunk = chunk;
    } else if (chunk) {
      rawChunk = chunk.toString();
    }
    allStdout += rawChunk;
    chunks.push(rawChunk);
  };

  const consoleOverride = {
    log: (...args) => args.forEach(handleChunk),
    error: (...args) => args.forEach(handleChunk),
    warn: (...args) => args.forEach(handleChunk),
    info: (...args) => args.forEach(handleChunk)
  };

  if (intercept) {
    unhook = interceptStdout(handleChunk, handleChunk);
  }

  const inputString = Array.isArray(inputLabel) ? inputLabel.join(', ') : inputLabel;

  const isBrowser = typeof window !== 'undefined' && typeof window?.document !== 'undefined';
  const executionMode = isBrowser ? 'browser' : useVM === false ? 'plain' : useVM === true ? 'vm' : 'blocked';

  const instrumentedExpression = executionMode !== 'vm' && isBrowser ? instrumentCodeWithLoopProtection(expression) : expression;
  const arrowExpressionString = `(${inputString}) => (
    ${instrumentedExpression}
  )`;
  const fnExpressionString = `(${inputString}) => {
    ${instrumentedExpression}
  }`;

  if (executionMode !== 'vm') {
    wrapGlobalVariables(globalVariables);
  }

  const expressionString = evalMode === true ? expression : arrowFunction ? arrowExpressionString : fnExpressionString;
  let result;
  try {
    const inputs = Array.isArray(inputLabel) ? inputLabel.length : 1;
    const args = Array(inputs).fill(input); // Creates an array with `inputs` number of `input`
    result = await execEvaluateExpression({ executionMode, expression, expressionString, args, meta, globalVariables, consoleOverride, evalMode });
  } catch (e) {
    result = { success: false, data: [formatErrorAsObject(e)], message: 'Error evaluating expression.' };
  } finally {
    if (typeof unhook === 'function') {
      unhook();
    }
    if (executionMode !== 'vm') {
      unwrapGlobalVariables(globalVariables);
    }
  }

  const resultMeta = result && result.meta ? result.meta : {};
  const stdout = resultMeta.stdout !== undefined ? resultMeta.stdout : allStdout;
  const stdoutChunks = resultMeta.stdoutChunks !== undefined ? resultMeta.stdoutChunks : chunks;
  return { ...result, meta: { ...resultMeta, stdout, stdoutChunks } };
};
